module.exports = __webpack_public_path__ + "static/strategies_inclusives-fb2871555a19da779bf0e67f059b6a8a.mp4";